import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import { EmailTemplateModel } from './EmailTemplateModel';
import { emailTemplateService } from './AssociateEmailTemplate.services';
import Multiselect from 'vue-multiselect'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


@Component({
    components:{
        quillEditor,
        Multiselect
    },
})
export default class AssociateEmailTemplate extends Vue{
    public emailTemplateModel!: EmailTemplateModel
    public submitted: boolean = false
    public errorMessage: string = '';
    public editorErrorMessage: string = '';
    public successMessage: string = '';
    public documentList: Array<string> =[];
    public resetFlag: boolean =false;
    public buttonDisabled: boolean = false;
    public content: string = '';
    public fullPage: boolean = false;
    public $loading: any;
    public selected = [];
    public options:Array<string> = [];
    public merror: string = "";
    constructor(){
        super();
    }
    
    data () {
        return {
          editorOption: {},
          content: '',
          documentList: [],
          emailTemplateModel: new EmailTemplateModel(),
          submitted: false,
          errorMessage: '',
          editorErrorMessage:'',
          successMessage:'',
          resetFlag: false,
          buttonDisabled: false,
          options:[],
          merror:''
        }
    }
    
    
    mounted(): void{
      this.getDocumentList();  
      console.log('state values - ',this.$store.state);
      
    }

    clearSEMessage(){
        if(this.emailTemplateModel.document_name.length > 0){
            this.merror = "";    
        }else{
            this.merror = "The Document Name field is required";    
        }       
          this.errorMessage = '';
          this.successMessage = '';
    }
    
    onEditorChange({ quill, html, text }){
        this.emailTemplateModel.email_body = text;
        // console.log('text - ',html)
        if(!html && this.resetFlag === false){
          // console.log("text found");
          this.editorErrorMessage = 'Template Body field is required.';
          // this.successMessage = '';
          // this.errorMessage = '';
          // console.log("text change - ",this.editorErrorMessage);
        }else{
          // console.log("text not found");
          this.editorErrorMessage = '';
          // this.successMessage = '';  
          // this.errorMessage = '';
          // console.log("text not change - ",this.editorErrorMessage);
        }
    }

    submitTemplate():void{
        console.log(this.emailTemplateModel);
        this.buttonDisabled = true;
        this.submitted = true;
        
        
        this.$validator.validate().then(valid => {
                if (valid && this.editorErrorMessage === '' &&this.merror === '') {
                  this.postEmailTemplate();
                }else{
                  this.buttonDisabled = false;
                  if(this.content !== ''){
                  }else{
                    this.editorErrorMessage = 'Template Body field is required.';
                    
                  }
                  if(this.emailTemplateModel.document_name !== ''){}
                  else{
                    this.merror = 'The Document Name field is required';
                  }
                }
            });        
        
    }

    public async postEmailTemplate(): Promise<void> {
        let templateDetails =JSON.stringify(this.emailTemplateModel);
        let parsedData = JSON.parse(templateDetails)
        let data = {
          data: parsedData
        }
        const self = this;
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // let token = this.$store.getters.getLoginToken.token;
        let token = localStorage.getItem("token");
        let context = this;
        const Res = emailTemplateService
          .postEmailTemplate(data,token)
          .then((response: any) => {
              this.buttonDisabled = false
              console.log("email submitted successfully");
              console.log(response.data);
              context.successMessage = "Email template uploaded successfully !";
              // this.$router.push('/email-template');
              debugger;
              let document_name = context.emailTemplateModel.document_name;
              
              // let index =  context.documentList.findIndex((x:any)=>x['document_name'] == document_name)
              let index = context.options.indexOf(document_name);
              
             
              if (index > -1){
                context.options.splice(index,1);
              }
              console.log('success - ',context.successMessage);
              
              context.emailTemplateModel.document_name = '';
              context.emailTemplateModel.email_body = '';
              context.emailTemplateModel.email_subject = '';
              context.emailTemplateModel.template_name = '';
              context.content = '';
              context.resetFlag = true;
              context.editorErrorMessage = '';
              context.$validator.reset();
              console.log(this.documentList);
              context.successMessage = "Email template uploaded successfully !";
              console.log(context.successMessage);
              // console.log(this.emailTemplateModel);
           
              // context.successMessage = 'Email template uploaded successfully!';
              // context.$root.$emit('success','Email template uploaded successfully!');
              loader.hide();
          })
          .catch((error: any) => {
            if (error.response) {
              this.buttonDisabled = false;
              console.log(error.response.data['data']['message']);
              console.log(error.response.status);
              console.log(error.response.headers);
          
          console.log(error.response.data);
          if(error.response.data['data']['message']){
            this.errorMessage = error.response.data['data']['message'];             
          }
          if (error.response.data['data']['message']['template_name']){
            this.errorMessage = 'Template name is already taken! Try another one.';
          }
          // if (error.response.data['data']['message']['email_body']){
          //   this.errorMessage = 'Email body can\'t be blank.';
          // }
          if (error.response.data['data']['message']['email_subject']){
            this.errorMessage = 'Email subject can\'t be blank.';
          }
          console.log('this is the error message');
          console.log(error.response.data);
        }
          loader.hide();
            
          });   
       
      }

      public async getDocumentList(): Promise<void> {
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // let token = this.$store.getters.getLoginToken.token;
        let token = localStorage.getItem("token");

        const Res = emailTemplateService
          .getDocumentList(token)
          .then((response: any) => {
            // console.log(response.data.data)
              let list = response.data.data.document_list;
              for(let i = 0; i < list.length; i++) {
                var obj = list[i];
                let name:string = obj.document_name
                this.options.push(name);
                console.log(obj.id);
            }
              console.log("document list is given below - ");
              console.log(this.documentList);
            loader.hide();
          })
          .catch((error: any) => {
            console.log(error);
            // console.log(error.response.data);
            loader.hide();
          });   
      }
      destroy():void{
        this.$root.$off('success');
      }
}